import { Flex, Loader as MantineLoader, useMantineTheme } from '@mantine/core'

import type { LoaderProps } from './Loader.types'

export function Loader({
  isAuthenticatedLayout = false,
  isMinimized = false,
}: LoaderProps) {
  const theme = useMantineTheme()

  let height = !isAuthenticatedLayout ? '100svh' : 'calc(100vh - 124px)'

  if (isMinimized) {
    height = '100%'
  }

  return (
    <Flex align="center" h={height} justify="center" w="100%">
      <MantineLoader color={theme.other.colors.blue} size="xl" type="dots" />
    </Flex>
  )
}
